export default __webpack_public_path__ + "static/media/u_Rwkg7FE7s-HD.c3519a7d.jpg";